<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../../assets/images/banner_list.jpg" />
            <div class="btext">
                <h3>股权/资金投资项目</h3>
                <p>最新金融快讯，全球投资信息，行业特色综合类新闻资讯</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>股权/资金投资</el-breadcrumb-item>
                <el-breadcrumb-item>股权/资金投资项目</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="2"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/ecInvestmentIntroduction' }">
                            <el-menu-item index="1"><span slot="title" >股权/资金投资介绍</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/efInvestmentProject' }">
                            <el-menu-item index="2"><span slot="title">股权/资金投资项目</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/successfulCase' }">
                            <el-menu-item index="3"><span slot="title">成功案例</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="news_detail">
                            <h1 class="title_news" v-if="showDetail">{{this.EfInvestmentProjectDetailArray.title}}</h1>
                            <div class="date_news" v-if="showDetail">发布日期：{{this.EfInvestmentProjectDetailArray.publishTime|date_from_unix_YearMonthDay}} &nbsp;&nbsp;&nbsp;&nbsp;发布人：{{this.EfInvestmentProjectDetailArray.publisher}}</div>
                            <div class="content_news" v-html="this.EfInvestmentProjectDetailArray.content"></div>

                            <div class="news_more" v-if="showDetail">
                                <a class="prev" v-on:click="getPrevious(EfInvestmentProjectDetailArray.rownum)" v-bind:class="{temporary: EfInvestmentProjectDetailArray.rownum==1}"><b>上一篇：</b>{{this.EfInvestmentProjectDetailArray.rownum==1?'没有上一篇':perviousTitle}}</a>
                                <a class="next" v-on:click="getNext(EfInvestmentProjectDetailArray.rownum)" v-bind:class="{temporary: EfInvestmentProjectDetailArray.rownum==this.lastOne}"><b>下一篇：</b>{{this.EfInvestmentProjectDetailArray.rownum==this.lastOne?'没有下一篇':nextTitle}}</a>
                                <div class="clear"></div>
                            </div>

                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import {reqEfInvestmentProjectsById,reqEfInvestmentProjectDetailPervious,reqEfInvestmentProjectDetailNext} from "../../../../api/contentManagement-api";
    export default {
        data(){
            return{
                showDetail:true,
                lastOne:'',
                perviousTitle:'',
                nextTitle:'',
                EfInvestmentProjectDetailArray:[],
            }
        },
        methods:{
            getEfInvestmentProjectDetail(id){
                reqEfInvestmentProjectsById({id:id}).then((res)=>{
                    if(res.data.code===1){
                        this.EfInvestmentProjectDetailArray=res.data.data;
                        this.getPerviousTitle(this.EfInvestmentProjectDetailArray.rownum);
                        this.getNextTitle(this.EfInvestmentProjectDetailArray.rownum);
                    }else{
                        this.EfInvestmentProjectDetailArray='<p>抱歉，暂无数据</p>';
                        this.showDetail=false;
                    }
                })

            },
            getPerviousTitle:function (rownum) {
                reqEfInvestmentProjectDetailPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                    }
                })
            },
            getNextTitle:function (rownum) {
                reqEfInvestmentProjectDetailNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.nextTitle=res.data.data.title;
                    }
                })
            },

//   上下篇内容
            getPrevious:function (rownum) {
                reqEfInvestmentProjectDetailPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.EfInvestmentProjectDetailArray=res.data.data;
                        this.getPerviousTitle(this.EfInvestmentProjectDetailArray.rownum);
                        this.getNextTitle(this.EfInvestmentProjectDetailArray.rownum);
                    }
                })
            },
            getNext:function (rownum) {
                reqEfInvestmentProjectDetailNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.EfInvestmentProjectDetailArray=res.data.data;
                        this.getPerviousTitle(this.EfInvestmentProjectDetailArray.rownum);
                        this.getNextTitle(this.EfInvestmentProjectDetailArray.rownum);
                    }
                })
            },


        },
        mounted(){
            var total=this.$route.query.total;
            this.lastOne=total;
            var id=this.$route.query.id;
            this.getEfInvestmentProjectDetail(id);

        },
    }
</script>
<style>

    .news_more {
        line-height: 1.6em; padding:24px 0; margin-top:24px;
    }
    .prev {
        float: left;
    }
    .next {
        float: right; text-align: right;
    }
    .temporary {
        pointer-events: none;
        filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
        -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
        opacity: 0.5; /*其他，透明度50%*/
    }
</style>


// WEBPACK FOOTER //
// src/components/contentManagement/ecInvestment/efInvestmentProject/EfInvestmentProjectDetail.vue